import data from '../data/lang.json'

export const getText = (key, lang) => {
	const node = data[key]
	if (!node || !node.translations) return undefined
	return node.translations[lang] || node.translations.english
}
